import { useEffect } from 'react';

export function useRunIf(fnc: () => void, conditions: boolean[]) {
  useEffect(() => {
    let returnType;
    if (conditions.every((value) => value)) {
      returnType = fnc();
    }
    return returnType;
  }, conditions);
}
